@if (currentAccount){
    <app-property-resume-bar [customer]="currentAccount"></app-property-resume-bar>
}
<app-inactivate-property-info [account]="currentAccount"></app-inactivate-property-info>
<div class="row">
  <div class="column">
    @if (propertyToInactivate) {<app-rental-property-info [property]="propertyToInactivate"></app-rental-property-info>}
  </div>
  <div class="column">
    <form [formGroup]="contactInfoForm" class="owner-form">
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Owner's Phone number</mat-label>
          <input formControlName="phone" matInput>
          <mat-error *ngIf="contactInfoForm && contactInfoForm.get('phone')?.hasError('required')">
            Phone number is required.
          </mat-error>
          <mat-error *ngIf="contactInfoForm && contactInfoForm.get('phone')?.hasError('pattern')">
            Please use a valid phone number.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="column">
          <mat-label>Owner's Email address</mat-label>
          <input formControlName="email" matInput>
          <mat-error *ngIf="contactInfoForm && contactInfoForm.get('email')?.hasError('required')">
            Email is required.
          </mat-error>
          <mat-error *ngIf="contactInfoForm && contactInfoForm.get('email')?.hasError('email')">
            Invalid email address.
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </div>
</div>
<app-task-action-bar [disabled]="disableSubmit" [currentTask]="currentTask"
                     (isTaskApproved)="isTaskApproved($event)"></app-task-action-bar>
